import { RouterModule } from "@angular/router";

import { canActivateForAppInError } from "../something-went-wrong/something-went-wrong.guard";
import { SignInWithUsernameComponent } from "./sign-in-with-username/sign-in-with-username.component";
import { ConfirmPasswordComponent } from "./confirm-password/confirm-password.component";
import { ConfirmPasswordGuard } from "./confirm-password/guards/confirm-password.guard";
import { AuthenticatedGuard, NotAuthenticatedGuard, SelectOrganisationGuard } from "../shared";
import { TermsConditionsComponent } from "./terms-conditions/terms-conditions.component";
import { MfaActivationComponent } from "./mfa-activation/mfa-activation.component";
import { MfaEntryComponent } from "./mfa-entry/mfa-entry.component";
import { SignInComponent } from "./sign-in/sign-in.component";
import { SetupComponent } from "app/setup/setup.component";
import { MustSetMainFunctionProblemComponent } from "./must-set-main-function-problem/must-set-main-function-problem.component";
import { UnknownProblemComponent } from "./unknown-problem/unknown-problem.component";
import { SignOutComponent } from "./sign-out/sign-out.component";

export const routing = RouterModule.forChild([
	{
		path: "select-organisation",
		component: SetupComponent,
		canActivate: [canActivateForAppInError, SelectOrganisationGuard],
	},
	{
		path: "auth",
		children: [
			{
				path: "",
				redirectTo: "/select-organisation",
				pathMatch: "full",
			},
			{
				path: "sign-in",
				component: SignInComponent,
				canActivate: [canActivateForAppInError, NotAuthenticatedGuard],
			},
			{
				path: "sign-out",
				component: SignOutComponent,
				canActivate: [canActivateForAppInError, AuthenticatedGuard],
			},
			{
				path: "sign-in-with-username",
				component: SignInWithUsernameComponent,
				canActivate: [canActivateForAppInError, NotAuthenticatedGuard],
			},
			{
				path: "confirm-password",
				component: ConfirmPasswordComponent,
				canActivate: [canActivateForAppInError, ConfirmPasswordGuard, NotAuthenticatedGuard],
			},
			{
				path: "mfa-activation",
				component: MfaActivationComponent,
				canActivate: [canActivateForAppInError, NotAuthenticatedGuard],
			},
			{
				path: "mfa-entry",
				component: MfaEntryComponent,
				canActivate: [canActivateForAppInError, NotAuthenticatedGuard],
			},
			{
				path: "terms-conditions",
				component: TermsConditionsComponent,
				canActivate: [canActivateForAppInError],
			},
			{
				path: "unknown-problem",
				component: UnknownProblemComponent,
				canActivate: [canActivateForAppInError, NotAuthenticatedGuard],
			},
			{
				path: "must-set-main-function",
				component: MustSetMainFunctionProblemComponent,
				canActivate: [canActivateForAppInError, NotAuthenticatedGuard],
			},
		],
	},
]);
